import React from "react";
import PropTypes from "prop-types";
import MenuItem from "@material-ui/core/MenuItem";

function Suggestion({
	suggestion,
	index,
	itemProps,
	highlightedIndex,
	selectedItem,
}) {
	const isHighlighted = highlightedIndex === index;
	const isSelected = selectedItem === suggestion;
	//const isSelected = (selectedItem || '').indexOf(suggestion.name) > -1;

	return (
		<MenuItem
			{...itemProps}
			key={suggestion.id}
			selected={isHighlighted}
			component="div"
			style={{
				fontWeight: isSelected ? 500 : 400,
			}}
		>
			{suggestion.name}
		</MenuItem>
	);
}

Suggestion.propTypes = {
	highlightedIndex: PropTypes.number,
	index: PropTypes.number,
	itemProps: PropTypes.object,
	selectedItem: PropTypes.object,
	suggestion: PropTypes.object.isRequired,
};

export default Suggestion;
